import { FormikCheckboxField, Modal, ModalContentContainer, FormikAutocompleteField, FormikRatingField } from "@pinkyhead/dovekit"
import { Field, Form, Formik } from "formik";
import { ReactComponent as SearchIcon } from "../../../../assets/icons/regular/search.svg"
import { Container as CategoryContainer, Button } from "../../../common/CategoryFilters/CategoryFilters.styles";
import { filtersList as cateroriesList } from "../../../common/CategoryFilters/utils";
import { useFilters } from "./Filters.hooks"
import { FiltersProps } from "./Filters.interface";
import { Container, GridWrapper } from "./Filters.styles";
import { filtersList } from "./utils";

export const Filters = ({ open, setOpen }: FiltersProps) => {
  const {
    formikRef,
    handleSubmit,
    activeTab,
    savedFilters,
    clearSearchParams,
    searchValue,
    setSearchValue,
    specialitiesOptions,
    isMobile,
    handleCategoryChange,
    businessOptions,
    businessCategorySearchName,
    setBusinessCategorySearchName,
    claimActive,
    searchStateValue,
    setSearchStateValue,
    states,
    cities,
    setSearchCityValue,
    searchCityValue
  } = useFilters(setOpen);
  return (
    <div>
      <Formik
        initialValues={savedFilters}
        onSubmit={handleSubmit}
        innerRef={formikRef}
      >
        <Form>
          <Modal
            open={open}
            header={{
              title: "Filters",
              closeCallback: () => setOpen(false)
            }}
            footer={{
              primaryButton: {
                children: "Submit",
                onClick: () => formikRef.current ? formikRef.current.submitForm() : undefined
              },
              secondaryButton: {
                children: "Clear",
                onClick: () => clearSearchParams()
              }
            }}
          >
            <ModalContentContainer footer header fullScreen={false}>
              <Container>
                {(isMobile && !claimActive) &&
                  <CategoryContainer className="container">
                    {cateroriesList.map((each) => (
                      <Button
                        active={activeTab === each.value}
                        onClick={() => handleCategoryChange(each)}
                      >
                        {each.label}
                      </Button>
                    ))}
                  </CategoryContainer>
                }
                {filtersList.find(({ tabName }) => tabName === activeTab)?.filters.map((each, index) => (
                  <>
                    {each.length > 1 
                      ?
                        <GridWrapper key={index}>
                          {each.map((field) => (
                            <Field
                              key={field.id}
                              {...field}
                              fullWidth
                              />
                          ))}
                        </GridWrapper>
                      : 
                        <Field
                          {...each[0]}
                          key={each[0].id}
                          fullWidth
                        />
                      }
                  </>
                ))}
                {activeTab === "physician" &&
                  <>
                    <Field 
                      label="Speciality"
                      fullWidth
                      component={FormikAutocompleteField}
                      name="speciality"
                      searchValue={searchValue}
                      setSearchValue={setSearchValue}
                      options={specialitiesOptions}
                      decoratorStart={<SearchIcon />}
                      placeholder="Speciality"
                    />
                  </>
                }
                {activeTab === "Business" && 
                  <Field 
                    label="Business category"
                    fullWidth
                    component={FormikAutocompleteField}
                    name="category"
                    searchValue={businessCategorySearchName}
                    setSearchValue={setBusinessCategorySearchName}
                    options={businessOptions}
                    placeholder="Business category"
                  />
                }
                {activeTab !== 'all' &&
                  <GridWrapper>
                    <Field 
                      name="state"
                      label="State"
                      component={FormikAutocompleteField}
                      fullWidth
                      placeholder="State"
                      options={states}
                      setSearchValue={setSearchStateValue}
                      searchValue={searchStateValue}
                      decoratorStart={<SearchIcon />}
                    />
                    <Field 
                      name="city"
                      label="City"
                      component={FormikAutocompleteField}
                      fullWidth
                      placeholder="City"
                      options={cities}
                      setSearchValue={setSearchCityValue}
                      searchValue={searchCityValue}
                      decoratorStart={<SearchIcon />}
                    />
                  </GridWrapper>
                }
                {activeTab === "physician" &&
                  <Field 
                    component={FormikCheckboxField}
                    name="is_board_certified"
                    label="Is Board Certified"
                  />
                }
                <Field 
                  component={FormikCheckboxField}
                  name="is_recommended"
                  label="Is Recommended"
                />
                <Field 
                  component={FormikCheckboxField}
                  name="is_premium"
                  label="Is Premium"
                />
                <Field 
                  component={FormikCheckboxField}
                  name="is_claimed"
                  label="Is Claimed"
                />
                {activeTab !== 'nfp' && (
                  <Field 
                    name="rating_from"
                    component={FormikRatingField}
                    label="Rating from"
                  />
                )}
              </Container>
            </ModalContentContainer>
          </Modal>
        </Form>
      </Formik>
    </div>
  )
}
